<template>
  <div class="module-table">
    <el-table :data="paginatedData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="被投资企业名称" >
            <template slot-scope="scope">
              {{ scope.row.invested_enterprise_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="投资金额">
            <template slot-scope="scope">
              {{ scope.row.invest_amount|| '-' }}
            </template>
        </el-table-column>
        <el-table-column label="股权占比">
            <template slot-scope="scope">
              {{ scope.row.equity_proportion|| '-' }}
            </template>
        </el-table-column>
        <el-table-column label="认缴金额">
            <template slot-scope="scope">
              {{ scope.row.subcribe_amount|| '-' }}
            </template>
        </el-table-column>
        <el-table-column label="实缴金额">
            <template slot-scope="scope">
              {{ scope.row.paid_in_amount|| '-' }}
            </template>
        </el-table-column>
        <el-table-column label="投资时间">
            <template slot-scope="scope">
              {{ scope.row.invest_date|| '-' }}
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="moduleData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'externalInvestList',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.moduleData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '对外投资',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>